/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import Tabs from '~/components/tab';
import useApi from '~/hooks/useApi';
import { ReprocessamentoFaturaSolicitacaoDetalhes } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { cpfMask, creditCardMask } from '~/utils/masks';
import InvoiceView from '../components/invoiceView';
import { useInvoiceReprocess } from '../context';
import * as St from '../styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: FormField;
}
const formInitialState = {
  cpf: { name: 'cpf', value: '' },
  numeroCartao: { name: 'numeroCartao', value: '' },
  nome: { name: 'nome', value: '' },
};
interface ReprocessamentoHistoricoDetalhesLocationState {
  dataAprovacaoRejeicao: string;
  dataSolicitacao: string;
  idSolicitacao: string;
  nomeCompleto: string;
  numeroChamado: string;
  situacao: string;
  nomeUsuarioAprovador: string;
  idUsuarioAprovador: string;
}
const InvoiceReprocessHistoricDetails = () => {
  const history = useHistory();
  const [list, setList] = useState([]);
  const [form, setForm] = useState<Form>(formInitialState);
  const {
    state,
  } = useLocation<ReprocessamentoHistoricoDetalhesLocationState>();
  console.log(state);
  const {
    dataAprovacaoRejeicao,
    dataSolicitacao,
    idSolicitacao,
    nomeCompleto,
    numeroChamado,
    idUsuarioAprovador,
    nomeUsuarioAprovador,
    situacao,
  } = state;
  const { solicitationData, setSolicitationData } = useInvoiceReprocess();
  const GetSolicitationDetails = useApi<ReprocessamentoFaturaSolicitacaoDetalhes>(
    {
      url: Endpoints.reprocess.getSolicitationDetails.replace(
        'PARAM_ID',
        state?.idSolicitacao,
      ),
      tryNewWay: true,
      fetchOnMount: true,
      enabled: !!state?.idSolicitacao,
    },
  );

  useEffect(() => {
    if (GetSolicitationDetails.data) {
      setSolicitationData({
        ...GetSolicitationDetails.data,
        id: state?.idSolicitacao,
      });
    }
  }, [GetSolicitationDetails.data]);

  if (GetSolicitationDetails.isFetched && GetSolicitationDetails.error) {
    return (
      <Container>
        <St.BoxCard>
          <St.BoxCardTitle>
            Houve um erro ao buscar os dados do histórico
          </St.BoxCardTitle>
          <Button
            loading={GetSolicitationDetails.loading}
            disabled={GetSolicitationDetails.loading}
            onClick={() => GetSolicitationDetails.refetch()}
          >
            Tentar novamente
          </Button>
        </St.BoxCard>
      </Container>
    );
  }

  return (
    <>
      <Loading status={GetSolicitationDetails.loading} />

      <Container>
        <St.BoxCard>
          <St.BoxCardTitle>Dados do cliente</St.BoxCardTitle>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                value={
                  cpfMask(GetSolicitationDetails.data?.cliente?.cpf)?.masked
                }
                onChange={(e) => setFormState(e, form, setForm)}
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                value={
                  creditCardMask(
                    GetSolicitationDetails.data?.cliente?.numeroCartao,
                  )?.masked
                }
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <Input
                label="Nome"
                onChange={(e) => {}}
                name={'clientName'}
                value={GetSolicitationDetails.data?.cliente?.nome}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Status do cartão "
                onChange={(e) => {}}
                name={'clientCardStatus'}
                value={GetSolicitationDetails.data?.cliente?.statusCartao}
              />
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
        <ContainerFlex row space gap="24" horizontal>
          <ContainerFlex maxWidth={40} flex={1}>
            <St.BoxCard>
              <St.BoxCardTitle>Dados do solicitante</St.BoxCardTitle>
              <ContainerFlex space>
                <ContainerFlex padding={16}>
                  <Input
                    label="Data solicitação"
                    value={moment(dataSolicitacao).format('DD/MM/YYYY HH:mm')}
                    onChange={(e) => {}}
                    maxLength={14}
                  />
                </ContainerFlex>
                <ContainerFlex padding={16}>
                  <Input
                    label="Nome operador"
                    onChange={(e) => setFormState(e, form, setForm)}
                    value={GetSolicitationDetails.data?.nomeSolicitante}
                  />
                </ContainerFlex>
              </ContainerFlex>
            </St.BoxCard>
          </ContainerFlex>
          <ContainerFlex flex={1}>
            <St.BoxCard>
              <ContainerFlex padding={16}>
                <St.BoxCardTitle>Dados do reprocessamento</St.BoxCardTitle>
                <ContainerFlex space row horizontal gap="8">
                  <Input
                    label="Nr do chamado"
                    onChange={(e) => {}}
                    name={'numeroProtocoloInterno'}
                    value={GetSolicitationDetails.data?.numeroProtocoloInterno}
                  />
                  <Input
                    label="Situação"
                    onChange={(e) => {}}
                    name={'situacao'}
                    value={situacao}
                  />
                  <Input
                    label="Data aprovação/rejeição"
                    onChange={(e) => {}}
                    name={'dataAprovacaoRejeicao'}
                    value={moment(dataAprovacaoRejeicao).format(
                      'DD/MM/YYYY HH:mm',
                    )}
                  />
                  <Input
                    label="Operador responsável"
                    onChange={(e) => {}}
                    name={'nomeUsuarioAprovador'}
                    value={nomeUsuarioAprovador}
                  />
                </ContainerFlex>
              </ContainerFlex>
            </St.BoxCard>
          </ContainerFlex>
        </ContainerFlex>

        {solicitationData?.faturas ? (
          <Tabs initialTab={0}>
            {solicitationData?.faturas?.map((f) => {
              return (
                <Tabs.Tab
                  label={`Fatura ${moment(
                    f.dataVencimento,
                    'YYYY-MM-DD',
                  ).format('DD/MM/YYYY')}`}
                  disabled={false}
                >
                  <InvoiceView readOnly data={f} />
                </Tabs.Tab>
              );
            })}
          </Tabs>
        ) : null}
      </Container>
    </>
  );
};

export default InvoiceReprocessHistoricDetails;
